import { render, staticRenderFns } from "./maintrtable.vue?vue&type=template&id=4b07bedb"
import script from "./maintrtable.vue?vue&type=script&lang=js"
export * from "./maintrtable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports